import { RootDispatch, RootState } from '../store';

export interface MessageLoadState {
  direction: string;
  initial: boolean;
  loading: boolean;
  replay: boolean;
  messageIdSnapshot: string[];
}

const initialState: MessageLoadState = {
  initial: false,
  direction: '',
  loading: false,
  replay: false,
  messageIdSnapshot: [],
};

export const messageLoad = {
  effects: (dispatch: RootDispatch) => ({
    startMessageLoader(direction: string) {
      dispatch.messageLoad.updateMessageLoader({ loading: true, direction });
    },
    stopMessageLoader() {
      dispatch.messageLoad.updateMessageLoader({ loading: false, direction: '' });
    },
    initialLoadComplete() {
      dispatch.messageLoad.updateMessageLoader({ initial: true });
    },
    replayChange(replayStatus: string, rootState: RootState) {
      const payload = {
        replay: replayStatus === 'replayStart',
        ...(replayStatus === 'replayStop'
          ? { messageIdSnapshot: Object.keys(rootState.messages) }
          : null),
      };
      dispatch.messageLoad.updateMessageLoader(payload);
    },
  }),
  reducers: {
    updateMessageLoader(state: MessageLoadState, payload: object): MessageLoadState {
      return Object.assign({}, state, payload);
    },
  },
  state: initialState,
};
